export const FORM_DATA = 'FORM_STEP';
export const CURRENT_STEP = 'CURRENT_STEP';
export const RESET_FORM = 'RESET_FORM';
export const BACK_STEP = 'BACK_STEP';
